import React, { useMemo,useRef } from "react";
import { Card, Button } from "react-bootstrap";
import { CountryFilter } from "./country-filter/CountryFilter";
import { CountryTable } from "./country-table/CountryTable";
import { useCountryUIContext } from "./CountryUIContext";

export function CountryCard({
  isLoading,
  filterValues,
  handleFilterValues,
  handleAddCountryShow,
  countryListTotalCount,
  currentPage,
  handleReset,
  setCurrentPage,
  // paginateCountryList,
  countryList,
}) {
  const countryUIContext = useCountryUIContext();
  const countryUIProps = useMemo(() => {
    return {
      ids: countryUIContext.ids,
      queryParams: countryUIContext.queryParams,
      setQueryParams: countryUIContext.setQueryParams,
      openReceiptDialog: countryUIContext.openReceiptDialog,
      openDeleteDialog: countryUIContext.openDeleteDialog,
      openEditDialog: countryUIContext.openEditDialog,
    };
  }, [countryUIContext]);
  const myRef = useRef(null);
  const onhandleReset = () => {
    myRef.current.click();
  };
  return (
    <>
      <Card className="card-custom card-stretch make-payment-wrapper">
        <Card.Header className="align-items-center border-bottom mt-4 d-none d-lg-flex">
          <h3 className="card-title align-items-start flex-column">
            <span className="font-weight-bold text-dark">Countries</span>
          </h3>
          <Button
            type="button"
            className="btn btn-secondary btn-lg"
            onClick={onhandleReset}
          >
            Reset
          </Button>
          <Button
            variant="btn btn-light-primary btn-lg "
            onClick={handleAddCountryShow}
          >
            New Country
          </Button>
          
        </Card.Header>
        <Card.Body>
          <CountryFilter filterValues={handleFilterValues} myRef={myRef} handleReset={handleReset} />
          <CountryTable
            isLoading={isLoading}
            filterValues={filterValues}
            countryListTotalCount={countryListTotalCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            // paginateCountryList={paginateCountryList}
            countryList={countryList}
          />
        </Card.Body>
      </Card>
    </>
  );
}
